import { StreamPartIDUtils } from '@streamr/utils';
export async function waitForAssignmentsToPropagate(messages, targetStream, loggerFactory) {
    const foundPartitions = new Set;
    for await (const msg of messages) {
        const streamPart = msg.content.streamPart;
        try {
            const streamPartId = StreamPartIDUtils.parse(streamPart);
            const [streamId, partition] = StreamPartIDUtils.getStreamIDAndPartition(streamPartId);
            if ((streamId === targetStream.id) && (partition < targetStream.partitions)) {
                foundPartitions.add(partition);
                if (foundPartitions.size === targetStream.partitions) {
                    return;
                }
            }
        }
        catch {
            loggerFactory.createLogger('waitForAssignmentsToPropagate').debug('Ignore malformed content');
        }
    }
}
//# sourceMappingURL=waitForAssignmentsToPropagate.js.map